import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/NavBar';

const RegisterPage = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('Ziyaretçi');
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const currentUsername = payload.username || 'Ziyaretçi';
        setUsername(currentUsername);
        if (currentUsername !== 'Ziyaretçi') navigate('/panel');
      } catch {
        setUsername('Ziyaretçi');
      }
    }
  }, [navigate]);

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const validationErrors = {};

    if (!formData.username.trim()) validationErrors.username = 'Kullanıcı adı zorunludur.';
    if (!formData.email.trim()) {
      validationErrors.email = 'E-posta zorunludur.';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      validationErrors.email = 'Geçerli bir e-posta giriniz.';
    }
    if (!formData.password) {
      validationErrors.password = 'Şifre zorunludur.';
    } else if (formData.password.length < 6) {
      validationErrors.password = 'Şifre en az 6 karakter olmalı.';
    }
    if (!formData.confirmPassword) {
      validationErrors.confirmPassword = 'Şifre tekrar zorunludur.';
    } else if (formData.password !== formData.confirmPassword) {
      validationErrors.confirmPassword = 'Şifreler uyuşmuyor.';
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setLoading(false);
      return;
    }

    try {
      const response = await fetch('https://klima-backend-ggo2.onrender.com/api/auth/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: formData.username,
          email: formData.email,
          password: formData.password,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        setErrors({ general: data.message || 'Kayıt başarısız oldu.' });
        return;
      }

      alert('Kayıt başarılı! Giriş sayfasına yönlendiriliyorsunuz.');
      navigate('/giris');
    } catch (error) {
      setErrors({ general: 'Sunucuya bağlanırken hata oluştu.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar username={username} />

      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }

          @keyframes slowZoom {
            0% { transform: scale(1); }
            100% { transform: scale(1.04); }
          }
        `}
      </style>

      <div style={{
        position: 'relative',
        minHeight: '100vh',
        animation: 'fadeIn 0.5s ease-in-out',
      }}>
        <div style={{
          position: 'absolute',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundImage: 'url("/assets/register-bg.png")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          animation: 'slowZoom 7s ease-in-out infinite alternate',
          zIndex: 0
        }} />

        <div style={{
          position: 'absolute',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.25)',
          zIndex: 1,
        }} />

        <div style={{
          position: 'relative',
          zIndex: 2,
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          paddingTop: '80px',
          paddingLeft: '16px',
          paddingRight: '16px',
          paddingBottom: '16px',
          minHeight: '100vh',
        }}>
          <div style={{
            background: 'white',
            padding: '32px 28px',
            borderRadius: '16px',
            boxShadow: '0 8px 20px rgba(0,0,0,0.08)',
            width: '100%',
            maxWidth: '440px',
            fontFamily: 'Segoe UI, sans-serif'
          }}>
            <h2 style={{
              textAlign: 'center',
              marginBottom: '12px',
              fontSize: '1.6rem',
              color: '#1e293b'
            }}>
              📝 Kayıt Ol
            </h2>

            {errors.general && (
              <p style={{ color: 'red', textAlign: 'center', marginBottom: '16px' }}>
                {errors.general}
              </p>
            )}

            <form onSubmit={handleSubmit} noValidate style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {renderInput('username', 'Kullanıcı Adı', 'text', formData.username, errors.username, handleChange)}
              {renderInput('email', 'E-posta', 'email', formData.email, errors.email, handleChange)}
              {renderInput('password', 'Şifre', 'password', formData.password, errors.password, handleChange)}
              {renderInput('confirmPassword', 'Şifre Tekrar', 'password', formData.confirmPassword, errors.confirmPassword, handleChange)}

              <button
                type="submit"
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '12px',
                  backgroundColor: loading ? '#94a3b8' : '#10b981',
                  color: 'white',
                  fontSize: '16px',
                  fontWeight: '600',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  transition: 'background-color 0.3s'
                }}
              >
                {loading ? '🔄 Kayıt Olunuyor...' : 'Kayıt Ol'}
              </button>
            </form>

            <p style={{
              marginTop: '16px',
              textAlign: 'center',
              fontSize: '0.95rem',
              color: '#475569'
            }}>
              Zaten hesabın var mı?{' '}
              <button
                onClick={() => navigate('/giris')}
                style={{
                  color: '#10b981',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  padding: 0,
                  fontWeight: '600',
                }}
                type="button"
              >
                Giriş Yap
              </button>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

const renderInput = (name, label, type, value, error, onChange) => (
  <div style={{ display: 'flex', flexDirection: 'column' }}>
    <label htmlFor={name} style={{ fontWeight: '600', color: '#334155', marginBottom: '4px' }}>{label}</label>
    <input
      id={name}
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      placeholder=""
      style={{
        width: '100%',
        padding: '10px',
        borderRadius: '8px',
        fontSize: '15px',
        border: error ? '1.5px solid red' : '1.5px solid #cbd5e1',
        outline: 'none',
        transition: 'border-color 0.3s'
      }}
    />
    {error && <p style={{ color: 'red', fontSize: '0.85rem', marginTop: '4px' }}>{error}</p>}
  </div>
);

export default RegisterPage;
